// src/pages/CalculatorBudget.js
import React, { useState } from "react";

const standardItems = [
  "Operations",
  "Salaries",
  "Marketing",
  "Technology",
  "Legal & Compliance",
  "Miscellaneous",
];

export default function CalculatorBudget({ initialRows = [], onSave, onCancel }) {
  const [rows, setRows] = useState(
    initialRows.length ? initialRows : [{ item: "Operations", value: 0 }]
  );

  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = field === "value" ? Number(value) : value;
    setRows(updated);
  };

  const addRow = () => setRows([...rows, { item: "Operations", value: 0 }]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  const totalBudget = rows.reduce((sum, r) => sum + (r.value || 0), 0);

  const handleSave = () => {
    if (typeof onSave === "function") {
      onSave({ total: totalBudget, breakdown: rows });
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "8px",
        width: "600px",
        maxHeight: "80vh",
        overflowY: "auto",
        zIndex: 10001,
        padding: "20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      }}
    >
      <h4>Budget Breakdown</h4>

      <table className="w3-table-all" style={{ marginTop: "10px" }}>
        <thead>
          <tr>
            <th>Item</th>
            <th>Value (₹)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td>
                <select
                  value={row.item}
                  onChange={(e) => handleRowChange(i, "item", e.target.value)}
                >
                  {standardItems.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="number"
                  value={row.value}
                  onChange={(e) => handleRowChange(i, "value", e.target.value)}
                />
              </td>
              <td>
                <button className="w3-button w3-red" onClick={() => removeRow(i)}>✕</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="w3-button w3-light-grey" style={{ marginTop: "10px" }} onClick={addRow}>
        + Add Row
      </button>

      <div style={{ marginTop: "15px" }}>
        <strong>Total Budget: ₹{totalBudget.toLocaleString("en-IN")}</strong>
      </div>

      <div style={{ marginTop: "15px" }}>
        <button className="w3-button w3-teal" onClick={handleSave}>Save</button>
        <button className="w3-button w3-light-grey" style={{ marginLeft: "10px" }} onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
